import { APIInjection } from '..';
import { useSelector } from 'react-redux';
import { selectToken } from '../../../pages/auth/authSlice';
import { useApiInjectionQuery } from './useApiInjectionQuery';

export function useApiInjection(apiInjection?: APIInjection[]) {
  const token = useSelector(selectToken);
  const {
    data: injectedData = [],
    isLoading,
    status,
    error,
  } = useApiInjectionQuery(apiInjection, token);

  return {
    injectedData,
    isLoading,
    status,
    error,
  };
}
